// extracted by mini-css-extract-plugin
export var heading1 = "heading-module--heading1--a5963";
export var heading2 = "heading-module--heading2--aef34";
export var heading3 = "heading-module--heading3--3a365";
export var heading4 = "heading-module--heading4--477ef";
export var heading5 = "heading-module--heading5--ae5a2";